import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiservicesService } from '../../../apiservices.service';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-agih-e-borang-ejen-cukai',
  templateUrl: './agih-e-borang-ejen-cukai.component.html',
  styleUrls: ['./agih-e-borang-ejen-cukai.component.css']
})
export class AgihEBorangEjenCukaiComponent implements OnInit {

  //Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //Loader
  LoaderStatus: boolean = false;

  //Data Variables
  AgentList: any = "";
  AgentTotalRecord: any = "";

  //UI View Variables
  CurrentAgentIDView: any = "";
  CurrentAgentNameView: any = "";
  CurrentAgentIDNoView: any = "";
  CurrentAgentLicenseNoView: any = "";
  CurrentAgentStatusView: any = "";

  //Session Variable
  SessionFirmID: any = "";
  SessionStaffID: any = "";

  //UI Input Variables
  AgentInput: any = "";
  AgentIDNoInput: any = "";

  //Datatable Variables
  displayedColumns = ['agentname', 'agentidnno', 'agentapprovalno', 'action'];
  Records: any = new Array;
  RecordCount: any = "";
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSource = new MatTableDataSource();

  constructor(private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.top.updateTotal();
    this.GetAgent("",this.SessionFirmID, 0, 10);
  }

  async GetAgent(IDNo:any,FirmID: any, PageNum: any, PageSize: any) {
    this.LoaderStatus = true;
    let Params = {};
    if (IDNo == "") {
      Params = {
        "FirmID": FirmID,
        "StaffList": false,
        "AgentList": true,
        "OggFilter": true,
        "ActiveIndFilter": false,
        "PageNum": PageNum ?? 0,
        "PageSize": PageSize ?? 10
      };
    } else {
      Params = {
        "FirmID": FirmID,
        "IDNo": IDNo,
        "StaffList": false,
        "AgentList": true,
        "OggFilter": true,
        "ActiveIndFilter": false,
        "PageNum": PageNum ?? 0,
        "PageSize": PageSize ?? 10
      };
    }
    const result = await this.apiServices.GetAllStaff(Params);
    this.AgentTotalRecord = result.taxAgent.totalTaxAgent;
    this.dataSource = new MatTableDataSource(result.taxAgent.taxAgentRecords);
    this.LoaderStatus = false;
  }

  async GetListAgent(FirmID: any, Self: boolean) {
    let Params = {}
    if (Self) {
      Params = {
        "FirmID": FirmID,
        "TaxAgentID": sessionStorage.getItem('TaxAgentID'),
        "Role": "0204"
      }
    } else {
      Params = {
        "FirmID": FirmID,
        "Role": "0204"
      }
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentList = result;
  }

  paginatorEvent(e: PageEvent) {
    this.LoaderStatus = true;
    this.GetAgent("",this.SessionFirmID, e.pageIndex, e.pageSize);
  }

  DistributeView(CurrentTaxAgentID:any, CurrentAgentName:any, CurrentAgentIDNo:any, CurrentAgentLicenseNo:any, CurrentAgentStatus:any) {
    this.CurrentAgentIDView = CurrentTaxAgentID;
    this.CurrentAgentNameView = CurrentAgentName;
    this.CurrentAgentIDNoView = CurrentAgentIDNo;
    this.CurrentAgentLicenseNoView = CurrentAgentLicenseNo;
    this.CurrentAgentStatusView = (CurrentAgentStatus) ? "Aktif" : "Tidak Aktif";
    if (sessionStorage.getItem('TaxAgentID') !== null && this.CurrentAgentIDView === Number(sessionStorage.getItem('TaxAgentID')))
      this.GetListAgent(this.SessionFirmID, true);
    else if (sessionStorage.getItem('TaxAgentID') !== null && this.CurrentAgentIDView !== sessionStorage.getItem('TaxAgentID'))
      this.GetListAgent(this.SessionFirmID, false);
    else
      this.GetListAgent(this.SessionFirmID, false);
    
  }

  async DistributeSubmit(CurrentTaxAgentID: any, NewTaxAgentID: any) {
    if (CurrentTaxAgentID === "" || NewTaxAgentID === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
    } else if (CurrentTaxAgentID === NewTaxAgentID) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila pilih ejen cukai lain";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
    } else {
      const result = await this.apiServices.AgihToEjen(this.SessionFirmID, CurrentTaxAgentID, NewTaxAgentID, this.SessionStaffID);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
      } else {
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.AgentInput = "";
      }
    }
  }

  Submit(IDNo: any) {
    if (IDNo == "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan no. pengenalan";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
    } else {
      this.GetAgent(IDNo, this.SessionFirmID, 0, 0);
    }
  }
  Semula() {
    this.AgentInput = "";
    this.AgentIDNoInput = "";

    this.CurrentAgentIDView = "";
    this.CurrentAgentNameView = "";
    this.CurrentAgentIDNoView = "";
    this.CurrentAgentLicenseNoView = "";
    this.CurrentAgentStatusView = "";

    this.AgentTotalRecord = "";

    this.dataSource = new MatTableDataSource();
    this.paginator.firstPage();
    this.GetAgent("",this.SessionFirmID, 0, 10);
  }
}
